/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
/* eslint-disable no-case-declarations */
import {
  INVOICE_LIST,
  INVOICE_DETAIL,
  EXPORT_INVOICE,
  DO_PAYMENT,
  INVOICE_GET_SCHEMA
} from './types';
import { INVOICE_STATUS_PAID, INVOICE_STATUS_OVERDUE } from '../../../constants/ModelStatus';

import { actionForState } from '../../../utils/helpers';

const INITIAL_STATE = {
  fetchAction: {
    success: false,
    error: false,
    loading: false
  },
  invoiceDetailAction: {
    success: false,
    error: false,
    loading: false
  },
  updatePaymentAction: {
    success: false,
    loading: false,
    error: false
  }
};


export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case INVOICE_LIST.pending:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'pending')
      };
    case INVOICE_LIST.success:
      const isArrayResponse = Array.isArray(action?.payload);

      let aerosimpleList = [];
      let netSuiteList = [];
      if (isArrayResponse) {
        // Old response
        aerosimpleList = action.payload;
      } else {
        // New response
        aerosimpleList = action.payload?.aerosimple || [];
        netSuiteList = action.payload?.net_suite || [];
      }
      aerosimpleList = aerosimpleList.map((invoice) => {
        const d1 = new Date();
        const d2 = new Date(invoice.payment_due);

        if ((d1.getTime() >= d2.getTime()) && invoice.status !== INVOICE_STATUS_PAID) {
          return {
            ...invoice,
            status: INVOICE_STATUS_OVERDUE
          };
        }
        return invoice;
      });
      return {
        ...state,
        fetchAction: actionForState(state.action, 'success'),
        invoiceList: aerosimpleList,
        netSuiteList
      };
    case INVOICE_LIST.error:
      return {
        ...state,
        fetchAction: actionForState(state.action, 'error')
      };
    case INVOICE_DETAIL.pending:
      return {
        ...state,
        invoiceDetailAction: actionForState(state.action, 'pending')
      };
    case INVOICE_DETAIL.success:
      const invoiceDetail = action.payload;
      const d1 = new Date();
      const d2 = new Date(invoiceDetail.payment_due);
      if ((d1.getTime() >= d2.getTime()) && invoiceDetail.status !== INVOICE_STATUS_PAID) {
        invoiceDetail.status = INVOICE_STATUS_OVERDUE;
      }
      return {
        ...state,
        invoiceDetailAction: actionForState(state.action, 'success'),
        invoiceDetail: action.payload
      };
    case INVOICE_DETAIL.error:
      return {
        ...state,
        invoiceDetailAction: actionForState(state.action, 'error')
      };
    case EXPORT_INVOICE.success: {
      const link = document.createElement('a');
      link.href = action.payload;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return state;
    }
    case DO_PAYMENT.pending:
      return {
        ...state,
        updatePaymentAction: actionForState(state.action, 'pending')
      };
    case DO_PAYMENT.success: {
      return {
        ...state,
        updatePaymentAction: actionForState(state.action, 'success')
      };
    }
    case DO_PAYMENT.error:
      return {
        ...state,
        updatePaymentAction: actionForState(state.action, 'error')
      };
    case INVOICE_GET_SCHEMA.pending:
      return {
        ...state,
        schemaAction: actionForState(state.action, 'pending')
      };
    case INVOICE_GET_SCHEMA.success: {
      return {
        ...state,
        schemaAction: actionForState(state.action, 'success'),
        invoiceSchema: action.payload
      };
    }
    case INVOICE_GET_SCHEMA.error:
      return {
        ...state,
        schemaAction: actionForState(state.action, 'error')
      };
    default:
      return state;
  }
}
